import { Component, Input, OnChanges, OnInit , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { ToolService } from '@app/core/services/tool/tool.service';
import { PopoverController } from '@ionic/angular';
import { isNil } from '@app/shared/utils';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-program-search-filters-list',
    templateUrl: './program-search-filters-list.component.html',
    styleUrls: ['./program-search-filters-list.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class ProgramSearchFiltersListComponent implements OnChanges {
    constructor(private toolService: ToolService, private popoverController: PopoverController) {}

    @Input() list: any[];

    order = false;
    cities = false;
    states = false;

    trackByIndex = (index: number): number => index;

    ngOnChanges() {
        if (!isNil(this.list)) {
            if (this.list[0].label) {
                this.order = true;
            }
        }
    }

    pick(ev: any, item: any) {
        this.popoverController.dismiss({ ...item, checked: !item.checked });
    }

    clearList(ev: any) {
        this.popoverController.dismiss({ clear: true });
    }

    orderUp(ev: any, item: any) {
        this.list.forEach((el: any) => {
            el.checked = el.value === item.value ? true : false;
        });
        this.toolService.searchSortValue.next(item.value);
        this.toolService.searchSortLabel.next(item.label);
    }
}
